/**
 * Super-admin client CSV export for the medical PA orders worklist header.
 *
 * @module clientExportButton
 */

import { isCurrentUserSuperAdmin } from "@risalabs_frontend_org/auth-wrapper";
import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";
import { useExportForClient } from "../../../../hooks/useExportForClient";
import DownloadIcon from "../../../../svg/download-icon";

/**
 * Header control that downloads the client export CSV for the current filters.
 *
 * Hidden unless the signed-in user is a super admin. Stays inactive until a
 * search payload exists, and shows "Exporting" while the download is in flight.
 *
 * @param payload - Current worklist search payload, or null before the first fetch.
 */
const ClientExportButton = ({
  payload,
}: {
  payload: SearchForMedicalPaOrdersFromPostgresParams | null;
}) => {
  const isSuperAdmin = isCurrentUserSuperAdmin();
  const { exportClientCsv, loading } = useExportForClient();

  if (!isSuperAdmin) return null;

  return (
    <div
      className={`export-icon flex items-center gap-2 transition-all duration-300 ease-in hover:scale-105 hover:font-semibold ${
        loading || !payload ? "pointer-events-none opacity-50" : ""
      }`}
      onClick={() => {
        if (!payload || loading) return;
        void exportClientCsv(payload);
      }}
    >
      {loading ? "Exporting" : "Export"}
      <DownloadIcon width={18} height={18} />
    </div>
  );
};

export default ClientExportButton;
